import { LogLevel, PublicClientApplication } from "@azure/msal-browser";
import type { Configuration } from "@azure/msal-browser";

// Hardcoded configuration values
const clientId = "da4a0635-0f8a-4627-ab66-5f20e48107f0"; // MSAL Client ID
const tenantId = "15aa23df-65c3-4003-8940-4230b9bf7909"; // MSAL Tenant ID
const redirectUri = window.location.origin; // Dynamic redirect URI based on deployment
const apiScopeClientId = "8951c94a-362a-4936-998b-22e19f329846"; // API Scope Client ID

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId, // Application (client) ID from the app registration
    authority: `https://login.microsoftonline.com/${tenantId}`, // Zentura tenant ID
    redirectUri, // This must match the redirect URI in the app registration
  },
  cache: {
    cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues with IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Info,
    },
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"],
};

// Add scopes here for access token to be used at your API endpoints.
export const apiRequest = {
  scopes: [`api://${apiScopeClientId}/user_impersonation`],
};

// Initialize MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);
